import jQuery from 'jquery';

jQuery(($) => {
  'use strict';

  let fileList = $('#FileList');

  if (fileList.length > 0) {
    fileList.jtable({
      title: 'Files Available for Download',
      paging: true,
      pageSize: 15,
      gotoPageArea: 'none',
      sorting: true,
      saveUserPreferences: false,
      defaultSorting: 'nor ASC',
      selecting: true,
      selectOnRowClick: true,
      actions: {
        listAction: window.getFileListUrl
      },
      fields: {
        id: {
          title: 'ID',
          key: true,
          list: false
        },
        type: {
          title: 'File Type',
          width: '7%'
        },
        client: {
          title: 'Client Name',
          width: '13%',
          display: (data) => {
            if (data.record.client && data.record.client.hasOwnProperty('last_first')) {
              return data.record.client.last_first;
            } else {
              return '';
            }
          }
        },
        invoice_number: {
          title: 'Invoice #',
          width: '10%',
          display: (data) => {
            if (data.record.invoice_number) {
              return data.record.invoice_number;
            } else {
              return '';
            }
          }
        },
        nor: {
          title: 'Name on Record',
          width: '15%',
          display: (data) => {
            if (data.record.nor && data.record.nor.hasOwnProperty('display_name')) {
              return data.record.nor.last_first;
            } else {
              return '';
            }
          }
        },
        deponent_name: {
          title: 'Deponent',
          width: '22%',
          display: (data) => {
            if (data.record.deponent && data.record.deponent.hasOwnProperty('display_name')) {
              return data.record.deponent.display_name;
            } else {
              return '';
            }
          }
        },
        fka: {
          title: 'F.K.A.',
          width: '15%',
          display: (data) => {
            if (data.record.deponent && data.record.deponent.hasOwnProperty('former_name')) {
              return data.record.deponent.former_name;
            } else {
              return '';
            }
          }
        },
        uploaded_at: {
          title: 'Date Upload',
          width: '9%',
          display: (data) => {
            if (data.record.uploaded_at) {
              return new Date(data.record.uploaded_at).toLocaleDateString();
            } else {
              return '';
            }
          }
        },
        received_at: {
          title: 'Date Downloaded',
          width: '11%',
          display: (data) => {
            if (data.record.date_downloaded) {
              return new Date(data.record.date_downloaded).toLocaleDateString();
            } else {
              return '';
            }
          }
        },
        download: {
          title: '',
          display: (data) => {
            if (data.record.id) {
              return '<a title="Download" href="' + window.downloadBaseUrl + '/' + data.record.id +
                '" class="jtable-command-button" target="_blank"><img class="DownloadRecordsButton" src="' +
                window.downloadIconUrl + '" width="30" height="30"></a>';
            } else {
              return '';
            }
          },
          sorting: false,
          width: '5%'
        },
        receive: {
          title: '',
          display: (data) => {
            if (data.record.id) {
              return '<button title="Receive" type="button" class="jtable-command-button receive-records" data-record="' + data.record.id + '"><img class="ReceiveRecordsButton" src="' + window.receiveIconUrl +
                '" width="30" height="30" data-record="' + data.record.id + '"></button>';
            } else {
              return '';
            }
          },
          sorting: false,
          width: '5%'
        },
        unreceive: {
          title: '',
          display: (data) => {
            if (data.record.id) {
              return '<button title="Unreceive" class="jtable-command-button unreceive-records" data-record="' + data.record.id + '"><img class="UnreceiveRecordsButton" src="' +
                window.unreceiveIconUrl + '" width="30" height="30" data-record="' + data.record.id + '"></button>';
            } else {
              return '';
            }
          },
          sorting: false,
          width: '5%'
        }
      }
    });

    // Load all records when page is first shown
    fileList.jtable('load', {
      filter_filetype: $('#filter_filetype').val(),
      filter_nor: $('#filter_nor').val()
    });

    $('#LoadRecordsButton').click(() => {
      fileList.jtable('load', {
        filter_filetype: $('#filter_filetype').val(),
        filter_nor: $('#filter_nor').val()
      });
    });

    $('body').on('click', 'button.receive-records, .ReceiveRecordsButton', (evt) => {
      evt.stopPropagation();

      $.ajax({
        url: window.downloadBaseUrl + '/' + evt.target.getAttribute('data-record') + '/receive',
        type: 'post',
        success: () => {
          $('#FileList').jtable('reload');
        },
        beforeSend: $.noop,
        complete: $.noop
      });
    }).on('click', '.unreceive-records, .UnreceiveRecordsButton', (evt) => {
      evt.stopPropagation();

      $.ajax({
        url: window.downloadBaseUrl + '/' + evt.target.getAttribute('data-record') + '/unreceive',
        type: 'post',
        success: () => {
          $('#FileList').jtable('reload');
        },
        beforeSend: $.noop,
        complete: $.noop
      });
    });
  }
});